import { useTranslation } from 'react-i18next';
import { ContractTemplate } from '../../hooks/useContractTemplate';
import { CONTRACT_LOCALE_TO_LABEL_KEY } from '../../shared/supported-languages';
import { TabV2, TabsList, TabsTrigger, TabsContent } from '../TabV2/TabV2';
import GeneralSection from '../../pages/ContractsPage/sections/GeneralSection';
import OrderConditionsSection from '../../pages/ContractsPage/sections/OrderConditionsSection';
import PaymentMethodSection from '../../pages/ContractsPage/sections/PaymentMethodSection';
import RemarksSection from '../../pages/ContractsPage/sections/RemarksSection';
import AdditionalRequirementsSection from '../../pages/ContractsPage/sections/AdditionalRequirementsSection';
import { PermissionFlags } from '../PermissionFlags/PermissionFlags';
import WarningNotice from '../WarningNotice/WarningNotice';

type TemplateProps = {
  contractTemplate: ContractTemplate;
  updateContractTemplate: (value: any) => void;
  selectedLocale: string;
};

const ContractTemplateEditor: React.FC<TemplateProps> = ({ contractTemplate, updateContractTemplate, selectedLocale }) => {
  const { t } = useTranslation();
  const languageLabel = CONTRACT_LOCALE_TO_LABEL_KEY[selectedLocale]
    ? t(CONTRACT_LOCALE_TO_LABEL_KEY[selectedLocale])
    : selectedLocale;

  return (
    <PermissionFlags requiredFlags={['edit-contract-template']}>
      <div className="w-full">
        <WarningNotice
          className="mb-4"
          message={t('contract_template.modifying_for', { language: languageLabel })}
        />
        <TabV2 defaultValue="contract" className="w-full">
          <TabsList className="grid w-full grid-cols-2 py-[15px]">
            <TabsTrigger value="contract">
              {t("contract_template.contract.title") || "Contract"}
            </TabsTrigger>
            <TabsTrigger value="payment-method">
              {t("contract_template.payment_method.title") || "Payment Method"}
            </TabsTrigger>
          </TabsList>

          <TabsContent value="contract">
            <div className="flex flex-col gap-8">
              <GeneralSection
                contractTemplate={contractTemplate}
                updateContractTemplate={updateContractTemplate}
              />
              <OrderConditionsSection
                contractTemplate={contractTemplate}
                updateContractTemplate={updateContractTemplate}
              />
              <RemarksSection
                contractTemplate={contractTemplate}
                updateContractTemplate={updateContractTemplate}
              />
              <AdditionalRequirementsSection
                contractTemplate={contractTemplate}
                updateContractTemplate={updateContractTemplate}
              />
            </div>
          </TabsContent>

          <TabsContent value="payment-method">
            <PaymentMethodSection
              contractTemplate={contractTemplate}
              updateContractTemplate={updateContractTemplate}
            />
          </TabsContent>
        </TabV2>
      </div>
    </PermissionFlags>
  );
};

export default ContractTemplateEditor;
